import React from 'react';
import { Patient } from '@/lib/types';
import IntelliHealthSection from './intellihealth/IntelliHealthSection';
import PatientSummaryContent from './PatientSummaryContent';

interface PatientSummaryTabProps {
  patient: Patient | null;
  // Kept for API compatibility with the page; current Summary surface is
  // read-only — patient edits happen via the page-header drawer.
  onPatientUpdated?: () => void;
}

/**
 * Practitioner Summary tab.
 *
 * Layout (top to bottom):
 *   1. IntelliHealth Clinical Summary (modern card with status pill, key
 *      takeaways, action chips, recommendations)
 *   2. Allergy + Problem chip rows (safety-critical, glance-able)
 *   3. Vitals snapshot · Active medications · Upcoming visits (3-up grid)
 *
 * Demographics live in the page header. Patient Portal lives as a header
 * pill. Audit / Recent activity lives on the Timeline tab in secondary
 * nav. Detailed editing (weight/BP/medical history) lives on the Chart
 * tab — every block here links there for the deep view.
 */
export default function PatientSummaryTab({
  patient,
}: PatientSummaryTabProps) {
  return (
    <div className='space-y-6'>
      <IntelliHealthSection patient={patient} />
      <PatientSummaryContent patient={patient} />
    </div>
  );
}
